import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TestingPageComponent} from './testing-page/testing-page.component';
import {WidgetLibraryModule} from '../_widget-library/widget-library.module';
import {LayoutLibraryModule} from '../_layout-library/layout-library.module';
import {CommunicationCommonModule} from '../communication-common/communication-common.module';
import {ToastModule} from 'primeng/toast';
import {AuditModule} from '../audit/audit.module';
import {FlowvisgraphModule} from "../flowvisgraph/flowvisgraph.module";



@NgModule({
    declarations: [TestingPageComponent],
    exports: [
        TestingPageComponent
    ],
    imports: [
        CommonModule,
        WidgetLibraryModule,
        LayoutLibraryModule,
        CommunicationCommonModule,
        ToastModule,
        AuditModule,
        FlowvisgraphModule,
    ]
})
export class TestingGroundModule { }
